import React from "react";

export default () => {
  return (
    <div className="help__block">
      <i className="help__icon icon-phone" />
      <p className="help__subject">
        <b>Call 717-392-7472</b>
        <br />
        <span className="help__small">We do not accept phone orders</span>
      </p>
    </div>
  );
};
